module.exports = __webpack_public_path__ + "static/media/drums-course.5cf05eb1.jpg";